

import { useEffect, useState } from "react"
import BackToTop from '../elements/BackToTop'
import Footer1 from './footer/Footer1'
import Header1 from "./header/Header1"
import MobileMenu from './MobileMenu'
import ModalForgotPassword from "./ModalForgotPassword"
import ModalLogin from "./ModalLogin"
import ModalRegister from "./ModalRegister"



export default function Layout({ children, backAlt }) {
	const [scroll, setScroll] = useState(0)
	const [isMobileMenu, setMobileMenu] = useState(false)
	const handleMobileMenu = () => setMobileMenu(!isMobileMenu)


	const [isCart, setCart] = useState(false)
	const handleCart = () => setCart(!isCart)


	const [isLogin, setLogin] = useState(false)
	const handleLogin = () => {
		setLogin(!isLogin)
		!isLogin ? document.body.classList.add("modal-open") : document.body.classList.remove("modal-open")
	}


	const [isRegister, setRegister] = useState(false)
	const handleRegister = () => {
		setRegister(!isRegister)
		!isRegister ? document.body.classList.add("modal-open") : document.body.classList.remove("modal-open")
	}


	const [isForgotPass, setForgotPass] = useState(false)
	const handleForgotPass = () => {
		setForgotPass(!isForgotPass)
		!isForgotPass ? document.body.classList.add("modal-open") : document.body.classList.remove("modal-open")
	}


	useEffect(() => {
		if (typeof window !== "undefined") {
			require("wowjs/dist/wow.js");
			if (window.WOW) {
				new window.WOW({ live: false }).init();
			}
		}

		const onScroll = () => setScroll(window.scrollY > 100);
		window.addEventListener("scroll", onScroll);
		return () => window.removeEventListener("scroll", onScroll);
	}, []);


	return (
		<>
			<div id="top" />
			<Header1
				scroll={scroll}
				isMobileMenu={isMobileMenu}
				handleMobileMenu={handleMobileMenu}
				isCart={isCart}
				handleCart={handleCart}
				isLogin={isLogin}
				handleLogin={handleLogin}
				isRegister={isRegister}
				handleRegister={handleRegister}
				isForgotPass={isForgotPass}
				handleForgotPass={handleForgotPass}
			/>
			<MobileMenu isMobileMenu={isMobileMenu} handleMobileMenu={handleMobileMenu} />
			{children}
			< Footer1 />
			<BackToTop target="#top" backAlt={backAlt} />
			<ModalLogin
				isLogin={isLogin}
				handleLogin={handleLogin}
				isRegister={isRegister}
				handleRegister={handleRegister}
				isForgotPass={isForgotPass}
				handleForgotPass={handleForgotPass}
			/>
			<ModalRegister
				isRegister={isRegister}
				handleRegister={handleRegister}
				isLogin={isLogin}
				handleLogin={handleLogin}
			/>
			<ModalForgotPassword
				isForgotPass={isForgotPass}
				handleForgotPass={handleForgotPass}
				isLogin={isLogin}
				handleLogin={handleLogin}
			/>
		</>
	)
}
